export const MODEL_TYPE_ENUM = {
  NOTE: "note",
  USER: "user",
  CONTACT: "contact",
};
